export const idcMap: GenericObject = {
	codigocid: "code",
	descricaocid: "description",
};

export const attendanceIdcTypesMap = {
	cronica: "chronicDisease",
	diag_confirmado: "diagnosisConfirmed",
	hipotese_diagnos: "diagnosticHypothesis",
	principal: "mainIdc",
};

export const reversedAttendanceIdcTypesMap = Object.fromEntries(
	Object.entries(attendanceIdcTypesMap).map(([key, value]) => [value, key])
);

export const attendanceIdcMap: GenericObject = {
	atendimento_id: "attendanceId",
	atendimento_id_consultorio: "appointmentId",
	ciddescricao: "description",
	codigo: "code",
	...attendanceIdcTypesMap,
};
